module.exports = __webpack_public_path__ + "static/media/suitsetamise_keeld.63287dbd.svg";